import Layout from '@components/layout';
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import createOpenGraphTags from '@rsc/utils/createOpenGraphTags';
import Breadcrumb from '@components/breadcrumb';
import ContactForm from '@components/forms/ContactForm';
import styled from 'styled-components';
import parse from 'html-react-parser';
import { styles } from '@components/utils';
import PageWrapper from '@rsc/ui-components/page-wrapper/PageWrapper';
import KurgoContainer from '@components/utils/ContainerStyles';

const ContactContent = styled.div`
  img {
    width: 100%;
    height: auto;
  }

  h1 {
    font-weight: ${styles.fontWeight.medium};
    text-align: center;
    margin: 0;
    margin-bottom: 1rem;
  }

  // chat button from shogun Contact Us Content
  #mavenoidChatButtonContactUs {
    &:hover {
      text-decoration: underline;
    }
  }
`;

const ContactUsPage = ({ data }) => {
  const pageContent = data?.bodyContent?.nodes[0]?.body;
  useEffect(() => {
    document
      .querySelector('#mavenoidChatButtonContactUs')
      .addEventListener('click', () => {
        window?.mavenoidPushHandler();
      });
  }, []);

  return (
    <Layout
      headTagData={{
        title: 'Contact Us | Kurgo Dog Products',
        description:
          'Contact Kurgo at info@kurgo.com or 877-847-3868, Monday-Friday for assistance',
        keywords:
          'contact us, phone number, address, customer service, support',
        meta: createOpenGraphTags(
          {
            title: 'Contact Us | Kurgo Dog Products',
            description:
              'Contact Kurgo at info@kurgo.com or 877-847-3868, Monday-Friday for assistance',
            url: '/contact-us',
          },
          'kurgo'
        ),
      }}
    >
      <KurgoContainer backgroundColor={styles.colors.gray[100]}>
        <Breadcrumb
          elements={[
            { text: 'Home', link: '/' },
            { text: 'Go Together', link: '/go-together' },
            { text: 'Customer Support', link: '/customer-support' },
            { text: 'Contact Us', link: '/contact-us' },
          ]}
        />
        <PageWrapper>
          <ContactContent>{pageContent && parse(pageContent)}</ContactContent>
          <ContactForm />
        </PageWrapper>
      </KurgoContainer>
    </Layout>
  );
};

ContactUsPage.propTypes = {
  data: PropTypes.shape({
    bodyContent: PropTypes.shape({
      nodes: PropTypes.shape({
        body: PropTypes.string,
      }),
    }),
  }).isRequired,
};

export const query = graphql`
  query GetContactContent {
    bodyContent: allShopifyPage(filter: { handle: { eq: "contact-content" } }) {
      nodes {
        body
      }
    }
  }
`;

export default ContactUsPage;
